import { render, staticRenderFns } from "./editSeatsRow.vue?vue&type=template&id=3d56d8e4"
import script from "./editSeatsRow.vue?vue&type=script&lang=js"
export * from "./editSeatsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports